import { DeleteOutlined } from "@ant-design/icons";
import {
  Col,
  Modal,
  Row,
  Table,
  Select,
  Input,
  Button,
  message,
  Popconfirm,
} from "antd";
import React, { useState } from "react";

const { Option } = Select;
function ManipulationTable(props) {
  const [dataSource, setDataSource] = useState([]);

  const onClickAdd = () => {
    const newRow = {
      key: Date.now().toString(),
      node: "",
      value: "",
    };
    setDataSource([...dataSource, newRow]);
  };
  const handleDelete = (key) => {
    setDataSource(dataSource.filter((item) => item.key !== key));
  };
  const handleNodeChange = (value, record) => {
    const isDuplicate = dataSource.some((item) => item.node === value);
    if (isDuplicate) {
      message.error(
        "You have already made this selection. Please select a different column to update"
      );
      return;
    }
    const updatedData = dataSource.map((item) =>
      item.key === record.key
        ? {
            ...item,
            node: value,
            value: "",
          }
        : item
    );
    setDataSource(updatedData);
  };
  const columns = [
    {
      title: "",
      dataIndex: "delete",
      key: "delete",
      width: "4%",
      render: (_, record) => (
        <Popconfirm
          title="Are you sure?"
          onConfirm={() => handleDelete(record.key)}
        >
          <DeleteOutlined style={{ color: "red" }} />
        </Popconfirm>
      ),
    },
    {
      title: "Column/Node",
      dataIndex: "node",
      key: "node",
      responsive: ["md"],
      render: (_, record) => (
        <Select
          placeholder="Select a node"
          style={{ width: "100%" }}
          onChange={(value) => handleNodeChange(value, record)}
          value={record.node || undefined}
        >
          {props.nodes.map((node, index) => (
            <Option key={index} value={node.key}>
              {node.key}
            </Option>
          ))}
        </Select>
      ),
    },
    {
      title: "Value",
      dataIndex: "value",
      key: "value",
      render: (_, record) => (
        <Input
          value={record.value}
          disabled={!record.node}
          onChange={(e) =>
            setDataSource((prev) =>
              prev.map((item) =>
                item.key === record.key
                  ? { ...item, value: e.target.value }
                  : item
              )
            )
          }
        />
      ),
    },
  ];
  return (
    <div>
      <Modal open={props.isOpen} onCancel={props.handleModal}>
        <Row style={{ paddingBottom: "20px" }}>
          <p className="modal-header-text">Select Columns to update</p>
        </Row>
        <Row>
          <Col span={24}>
            <Table
              dataSource={dataSource}
              columns={columns}
              rowClassName="editable-row"
            />
          </Col>
        </Row>
        <Button
          onClick={onClickAdd}
          type="primary"
          style={{ marginBottom: 16, marginTop: 16 }}
        >
          Add mapping
        </Button>
      </Modal>
    </div>
  );
}

export default ManipulationTable;
